module.exports = __webpack_public_path__ + "media/images/country_flags/nf-f2211d425c8a9e7dfc7e0e9b08cfceb5.png";